import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actions from '../actions';


const dataSendingState = handleActions({
  [actions.sendDataRequest]() {
    return 'requested';
  },
  [actions.sendDataFailure]() {
    return 'failed';
  },
  [actions.sendDataSuccess]() {
    return 'finished';
  },
}, 'none');

const sendVerifyState = handleActions({
  [actions.sendVerifyRequest]() {
    return 'requested';
  },
  [actions.sendVerifyFailure]() {
    return 'failed';
  },
  [actions.sendVerifySuccess]() {
    return 'finished';
  },
}, 'none');

const getTokenStState = handleActions({
  [actions.getTokenStRequest]() {
    return 'requested';
  },
  [actions.getTokenStFailure]() {
    return 'failed';
  },
  [actions.getTokenStSuccess]() {
    return 'finished';
  },
}, 'none');

const tokenState = handleActions({
  [actions.getTokenStSuccess](state, action) {
    return action.payload.tokenState;
  },
}, '');

const token = handleActions({
  [actions.sendDataSuccess](state, action) {
    return action.payload.responseToken;
  },
}, '');

const form = handleActions({
  [actions.sendDataFailure]() {
    return 'errorForm';
  },
  [actions.sendVerifyFailure]() {
    return 'errorForm';
  },
  [actions.getTokenStFailure]() {
    return 'errorForm';
  },
  [actions.sendDataSuccess]() {
    return 'successForm';
  },
  [actions.setForm](state, action) {
    return action.payload.form;
  },
  [actions.getTokenStSuccess]() {
    return 'progressForm';
  },
}, 'userForm');

const responseLink = handleActions({
  [actions.sendDataSuccess](state, action) {
    return action.payload.responseLink;
  },
}, '');
const message = handleActions({
  [actions.sendDataSuccess](state, action) {
    return action.payload.message;
  },
}, '');
const responseError = handleActions({
  [actions.sendDataFailure](state, action) {
    return action.payload.responseError;
  },
  [actions.sendVerifyFailure](state, action) {
    return action.payload.responseError;
  },
  [actions.getTokenStFailure](state, action) {
    return action.payload.responseError;
  },
}, '');

const sslBool = handleActions({
  [actions.setSslCheck](state, action) {
    return action.payload.sslBool;
  },
}, true);

const correctData = handleActions({
  [actions.setCorrectData](state, action) {
    return action.payload.correctDataState;
  },
  [actions.sendVerifySuccess](state, action) {
    return action.payload.correctDataState;
  },
}, 'changed');

export default combineReducers({
  correctData,
  responseLink,
  responseError,
  dataSendingState,
  form,
  message,
  getTokenStState,
  sendVerifyState,
  tokenState,
  token,
  sslBool,
});
